import * as Yup from 'yup';

export let initialValues = {}; // values are set when individual components are imported

/* === Validation Logic === */

const validate = ({ validation, key }) => {
    return {
        [key]: Yup.string().required(validation[key]),
    };
};

const ProfessionalEmailAddress = ({ validation }) => {
    return {
        ProfessionalEmailAddress: Yup.string()
            .email(validation.validEmail)
            .required(validation.ProfessionalEmailAddress),
    };
};

const RegistrationNumber = ({ validation }) => {
    return {
        RegistrationNumber: Yup.string()
            .matches(/^[a-zA-Z]{3}\d{10}$/, 'Please Enter in correct Format')
            .required(validation.RegistrationNumber),
    };
};

const Email = ({ validation }) => {
    return {
        Email: Yup.string()
            .email(validation.validEmail)
            .required(validation.Email),
    };
};

const InqueryType = ({ validation }) => {
    return {
        whatareyoulookingfor: Yup.string().required(validation.InqueryType),
    };
};

const Phone = ({ validation }) => {
    return {
        Phone: Yup.string()
            .matches(/^[+\s()0-9]*[-\s()0-9]*$/, validation.validPhone)
            .required(validation.Phone),
    };
};

const State = ({ validation }) => {
    return {
        State: Yup.string().when('Country', (country) => {
            const countries = [
                'United States',
                'Canada',
                'Australia',
                'New Zealand',
            ];
            if (countries.includes(country)) {
                return Yup.string().required(validation.State);
            }
        }),
    };
};

const PostalCode = ({ validation }) => {
    return {
        PostalCode: Yup.string().when('Country', {
            is: 'United States',
            then: Yup.string().required(validation.PostalCode),
        }),
    };
};

const Topics_Of_Interest__c = ({ validation }) => {
    return {
        Topics_Of_Interest__c: Yup.array().when('marketingRequested', {
            is: 'yes',
            then: Yup.array().min(1, validation.Topics_Of_Interest__c),
        }),
    };
};

const Product_s_of_Interest__c = ({ validation, language }) => {
    const main_languages = ['default', 'gb'];
    return {
        Product_s_of_Interest__c: Yup.array().when([], {
            is: () => main_languages.includes(language),
            then: Yup.array().min(1, validation.Product_s_of_Interest__c),
        }),
    };
};

const License_Locale__c = ({ validation }) => {
    return {
        License_Locale__c: Yup.string().test(
            'license state',
            validation.License_Locale__c,
            (val, context) => {
                if (
                    !val &&
                    context.parent.Country === 'United States' &&
                    (context.parent.Primary_Role__c ===
                        'Advanced practitioner' ||
                        context.parent.Primary_Role__c ===
                            'Allied Healthcare Professional' ||
                        context.parent.Primary_Role__c === 'Educator' ||
                        context.parent.Primary_Role__c === 'Nurse' ||
                        context.parent.Primary_Role__c ===
                            'Nurse practitioner' ||
                        context.parent.Primary_Role__c === 'Perfusionist' ||
                        context.parent.Primary_Role__c ===
                            'Physician Assistant')
                ) {
                    return false;
                } else {
                    return true;
                }
            }
        ),
    };
};

const nPI = ({ validation }) => {
    return {
        nPI: Yup.string().when('Country', (country) => {
            const countries = ['United States'];
            if (countries.includes(country)) {
                return Yup.string().required(validation.nPI);
            }
        }),
    };
};

const iallowEdwards = ({ validation }) => {
    return {
        iallowEdwards: Yup.array().min(1, validation.iallowEdwards),
    };
};

const Communication_Preference__pc = ({ validation, language }) => {
    const main_languages = ['default', 'gb'];
    return {
        Communication_Preference__pc: Yup.string().when('productCategory', {
            is: (value) =>
                value === 'Heart Valve Repair' &&
                main_languages.includes(language),
            then: Yup.string().required(
                validation.Communication_Preference__pc
            ),
        }),
    };
};

const Product_s_of_Interest__c_18716 = ({ validation, language }) => {
    const main_languages = ['default', 'gb'];
    return {
        Product_s_of_Interest__c: Yup.array().when(
            'productCategory',
            (productCategory) => {
                const categories = [
                    'Advanced Hemodynamic Monitoring',
                    'Pressure Monitoring',
                    'Vascular Surgery',
                    'Transcatheter Heart Valves',
                    'Surgical Heart Valves',
                    'Heart Valve Repair',
                ];
                if (
                    categories.includes(productCategory) &&
                    main_languages.includes(language)
                ) {
                    return Yup.array().min(
                        1,
                        validation.Product_s_of_Interest__c
                    );
                }
            }
        ),
    };
};

const Topics_Of_Interest__c_18716 = ({ validation, language }) => {
    const main_languages = ['default', 'gb'];
    return {
        Topics_Of_Interest__c: Yup.array().when(
            'productCategory',
            (productCategory) => {
                const categories = [
                    'Advanced Hemodynamic Monitoring',
                    'Pressure Monitoring',
                ];
                if (
                    categories.includes(productCategory) &&
                    main_languages.includes(language)
                ) {
                    return Yup.array().min(1, validation.Topics_Of_Interest__c);
                }
            }
        ),
    };
};

const iconfirmthatIhaveread = ({ validation }) => {
    return {
        iconfirmthatIhaveread: Yup.array().min(
            1,
            validation.iconfirmthatIhaveread
        ),
    };
};

const ELA_State = ({ validation }) => {
    return {
        State: Yup.string().when('Country', (country) => {
            const countries = ['United States'];
            if (countries.includes(country)) {
                return Yup.string().required(validation.State);
            }
        }),
    };
};

/* === Critical Care Forms === */

// General Contact
export const validationSchema_18630 = (validation, language) => {
    return Yup.object({
        ...validate({ validation, key: 'FirstName' }),
        ...validate({ validation, key: 'LastName' }),
        ...validate({ validation, key: 'Company' }),
        ...Email({ validation }),
        ...validate({ validation, key: 'Country' }),
        ...validate({ validation, key: 'City' }),
        ...State({ validation }),
        ...PostalCode({ validation }),
        ...Phone({ validation }),
        ...validate({ validation, key: 'Primary_Role__c' }),
        ...validate({ validation, key: 'Primary_Specialty__c' }),
        ...InqueryType({ validation }),
        ...validate({ validation, key: 'marketingRequested' }),
        ...Topics_Of_Interest__c({ validation }),
        ...Product_s_of_Interest__c({ validation, language }),
    });
};

// Vascular
export const validationSchema_18689 = (validation, language) => {
    return Yup.object({
        ...validate({ validation, key: 'FirstName' }),
        ...validate({ validation, key: 'LastName' }),
        ...validate({ validation, key: 'Company' }),
        ...Email({ validation }),
        ...validate({ validation, key: 'Country' }),
        ...validate({ validation, key: 'City' }),
        ...State({ validation }),
        ...PostalCode({ validation }),
        ...Phone({ validation }),
        ...validate({ validation, key: 'Primary_Role__c' }),
        ...validate({ validation, key: 'Primary_Specialty__c' }),
        ...InqueryType({ validation }),
        ...validate({ validation, key: 'marketingRequested' }),
        ...Topics_Of_Interest__c({ validation }),
        ...Product_s_of_Interest__c({ validation, language }),
    });
};

// Download
export const validationSchema_18690 = (validation) => {
    return Yup.object({
        ...validate({ validation, key: 'FirstName' }),
        ...validate({ validation, key: 'LastName' }),
        ...validate({ validation, key: 'Company' }),
        ...Email({ validation }),
        ...validate({ validation, key: 'Country' }),
        ...validate({ validation, key: 'City' }),
        ...State({ validation }),
        ...PostalCode({ validation }),
        ...Phone({ validation }),
        ...validate({ validation, key: 'Primary_Role__c' }),
        ...validate({ validation, key: 'Primary_Specialty__c' }),
        ...validate({ validation, key: 'marketingRequested' }),
        ...Topics_Of_Interest__c({ validation }),
        ...nPI({ validation }),
        ...License_Locale__c({ validation }),
    });
};

// Clinical Education Support
export const validationSchema_18984 = (validation) => {
    return Yup.object({
        ...validate({ validation, key: 'FirstName' }),
        ...validate({ validation, key: 'LastName' }),
        ...validate({ validation, key: 'Company' }),
        ...Email({ validation }),
        ...validate({ validation, key: 'Country' }),
        ...validate({ validation, key: 'City' }),
        ...State({ validation }),
        ...PostalCode({ validation }),
        ...Phone({ validation }),
        ...validate({ validation, key: 'Primary_Role__c' }),
        ...validate({ validation, key: 'Primary_Specialty__c' }),
        ...validate({ validation, key: 'marketingRequested' }),
        ...Topics_Of_Interest__c({ validation }),
    });
};

/* === Surgical Forms === */

// General Contact
export const validationSchema_18733 = (validation) => {
    return Yup.object({
        ...validate({ validation, key: 'FirstName' }),
        ...validate({ validation, key: 'LastName' }),
        ...validate({ validation, key: 'Company' }),
        ...Email({ validation }),
        ...validate({ validation, key: 'Country' }),
        ...validate({ validation, key: 'City' }),
        ...InqueryType({ validation }),
        ...State({ validation }),
        ...PostalCode({ validation }),
        ...Phone({ validation }),
        ...validate({ validation, key: 'Primary_Role__c' }),
        ...validate({ validation, key: 'Primary_Specialty__c' }),
        ...validate({ validation, key: 'marketingRequested' }),
        ...Topics_Of_Interest__c({ validation }),
    });
};

// /* === TMTT Forms === */

// General Contact
export const validationSchema_19505 = (validation) => {
    return Yup.object({
        ...validate({ validation, key: 'FirstName' }),
        ...validate({ validation, key: 'LastName' }),
        ...validate({ validation, key: 'Company' }),
        ...Email({ validation }),
        ...validate({ validation, key: 'Country' }),
        ...validate({ validation, key: 'City' }),
        ...InqueryType({ validation }),
        ...State({ validation }),
        ...PostalCode({ validation }),
        ...Phone({ validation }),
        ...validate({ validation, key: 'Primary_Role__c' }),
        ...validate({ validation, key: 'Primary_Specialty__c' }),
        ...validate({ validation, key: 'marketingRequested' }),
        ...Topics_Of_Interest__c({ validation }),
    });
};

/* === THV Forms === */

// Structural Heart
export const validationSchema_18715 = (validation) => {
    return Yup.object({
        ...validate({ validation, key: 'FirstName' }),
        ...validate({ validation, key: 'LastName' }),
        ...validate({ validation, key: 'Company' }),
        ...Email({ validation }),
        ...State({ validation }),
        ...validate({ validation, key: 'marketingRequested' }),
        ...nPI({ validation }),
    });
};

// TAVR Experience Feedback
export const validationSchema_18884 = (validation) => {
    return Yup.object({
        ...validate({ validation, key: 'FirstName' }),
        ...validate({ validation, key: 'LastName' }),
        ...Email({ validation }),
        ...validate({ validation, key: 'Address' }),
        ...validate({ validation, key: 'City' }),
        ...validate({ validation, key: 'State' }),
        ...validate({ validation, key: 'PostalCode' }),
        ...iallowEdwards({ validation }),
        multipurposeOptIn: Yup.array().when(['Country', 'State'], {
            is: (Country, State) =>
                Country === 'United States' &&
                ['CO', 'CT', 'VA'].includes(State),
            then: Yup.array().min(1, 'This field is required'),
        }),
    });
};

/* === CORP Forms === */

// Healthcare Professionals
export const validationSchema_18716 = (validation, language) => {
    if (language === 'kr') {
        return Yup.object({
            ...validate({ validation, key: 'FirstName' }),
            ...validate({ validation, key: 'LastName' }),
            ...Email({ validation }),
            ...Phone({ validation }),
            ...validate({ validation, key: 'productCategory' }),
            ...validate({ validation, key: 'whatareyoulookingfor' }),
            ...Communication_Preference__pc({ validation, language }),
            ...validate({ validation, key: 'Primary_Role__c' }),
            ...validate({ validation, key: 'Primary_Specialty__c' }),
            ...Product_s_of_Interest__c_18716({ validation, language }),
            ...Topics_Of_Interest__c_18716({ validation, language }),
            ...validate({ validation, key: 'Notes__c' }),
            ...validate({ validation, key: 'marketingRequested' }),
        });
    } else {
        return Yup.object({
            ...validate({ validation, key: 'FirstName' }),
            ...validate({ validation, key: 'LastName' }),
            ...Email({ validation }),
            ...Phone({ validation }),
            ...validate({ validation, key: 'Country' }),
            ...validate({ validation, key: 'City' }),
            ...State({ validation }),
            ...validate({ validation, key: 'PostalCode' }),
            ...validate({ validation, key: 'productCategory' }),
            ...validate({ validation, key: 'whatareyoulookingfor' }),
            ...Communication_Preference__pc({ validation, language }),
            ...validate({ validation, key: 'Primary_Role__c' }),
            ...validate({ validation, key: 'Primary_Specialty__c' }),
            ...Product_s_of_Interest__c_18716({ validation, language }),
            ...Topics_Of_Interest__c_18716({ validation, language }),
            ...validate({ validation, key: 'Notes__c' }),
            ...validate({ validation, key: 'marketingRequested' }),
        });
    }
};

// General Contact Inquiries

export const validationSchema_18718 = (validation, language) => {
    if (language === 'kr') {
        return Yup.object({
            ...validate({ validation, key: 'FirstName' }),
            ...validate({ validation, key: 'LastName' }),
            ...Email({ validation }),
            ...Phone({ validation }),
            ...validate({ validation, key: 'whatareyoulookingfor' }),
        });
    } else {
        return Yup.object({
            ...validate({ validation, key: 'FirstName' }),
            ...validate({ validation, key: 'LastName' }),
            ...Email({ validation }),
            ...Phone({ validation }),
            ...validate({ validation, key: 'Country' }),
            ...validate({ validation, key: 'City' }),
            ...State({ validation }),
            ...validate({ validation, key: 'Address' }),
            ...validate({ validation, key: 'whatareyoulookingfor' }),
        });
    }
};

// Patient Experience

export const validationSchema_18732 = (validation) => {
    return Yup.object({
        ...validate({ validation, key: 'FirstName' }),
        ...validate({ validation, key: 'LastName' }),
        ...Email({ validation }),
        ...Phone({ validation }),
        ...validate({ validation, key: 'Address' }),
        ...validate({ validation, key: 'Country' }),
        ...validate({ validation, key: 'City' }),
        ...State({ validation }),
        multipurposeOptIn: Yup.array().when(['Country', 'State'], {
            is: (Country, State) =>
                Country === 'United States' &&
                ['CO', 'CT', 'VA'].includes(State),
            then: Yup.array().min(1, 'This field is required'),
        }),
        ...validate({ validation, key: 'heartValve' }),
        ...validate({ validation, key: 'DateofBirth' }),
        ...validate({ validation, key: 'Lead_Source_Details__c' }),
        ...iconfirmthatIhaveread({ validation }),
    });
};

// Diversity

export const validationSchema_18809 = (validation) => {
    return Yup.object({
        ...validate({ validation, key: 'FirstName' }),
        ...validate({ validation, key: 'LastName' }),
        ...Email({ validation }),
        ...validate({ validation, key: 'employeeID' }),
        ...validate({ validation, key: 'eGRofinterest' }),
        ...validate({ validation, key: 'eRGRegion' }),
        ...validate({ validation, key: 'EU_Comments__pc' }),
    });
};

// Patient Voice

export const validationSchema_18848 = (validation) => {
    return Yup.object({
        ...validate({ validation, key: 'FirstName' }),
        ...validate({ validation, key: 'LastName' }),
        ...Email({ validation }),
        multipurposeOptIn: Yup.array().when(['Country', 'State'], {
            is: (Country, State) =>
                Country === 'United States' &&
                ['CO', 'CT', 'VA'].includes(State),
            then: Yup.array().min(1, 'This field is required'),
        }),
        ...validate({ validation, key: 'valveTreatmentsReceivedandDates' }),
        ...iallowEdwards({ validation }),
    });
};

// Edwards Learning App
export const validationSchema_FormEdwardsLearningApp = (validation) => {
    return Yup.object({
        ...validate({ validation, key: 'FirstName' }),
        ...validate({ validation, key: 'LastName' }),
        ...validate({ validation, key: 'ProfessionalEmailAddress' }),
        ...validate({ validation, key: 'TherapyOfInterest' }),
        ...validate({ validation, key: 'Role' }),
        ...validate({ validation, key: 'Specialty' }),
        ...validate({ validation, key: 'Country' }),
        ...validate({ validation, key: 'City' }),
        ...ELA_State({ validation }),
        ...validate({ validation, key: 'Hospital_InstitutionName' }),
    });
};

//Volunteer Request Form

const convertToNumber = (val) => {
    if (!val) return true;
    return parseInt(val.replace(':', ''));
};

const compareTime = (start, end) => {
    if (start < end) {
        return true;
    } else {
        return false;
    }
};

export const validationSchema_18929 = Yup.object({
    FirstName: Yup.string().required('First Name is a required field'),
    LastName: Yup.string().required('Last Name is a required field'),
    Email: Yup.string()
        .email('Email is invalid')
        .required('Email Address is a required field'),
    Website: Yup.string().matches(
        /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/,
        'Website is not a valid URL'
    ), // Website
    Phone: Yup.string()
        .matches(/^[+\s()0-9]*[-\s()0-9]*$/, 'Phone Number is not valid')
        .required('Phone Number is a required field'),
    cGHomePhoneNumber: Yup.string()
        .matches(/^[+\s()0-9]*[-\s()0-9]*$/, 'Phone Number is not valid')
        .required('Phone Number is a required field'),
    cEMItem14ProductNumber: Yup.string().test(
        'Compare Time',
        'Time is invalid',
        (val, context) => {
            if (val && context.parent.cEMItem14QuantityOrdered) {
                const start = convertToNumber(val);
                const end = convertToNumber(
                    context.parent.cEMItem14QuantityOrdered
                );
                return compareTime(start, end);
            } else {
                return true;
            }
        }
    ),
    cEMItem14QuantityOrdered: Yup.string().test(
        'Compare Time',
        'Time is invalid',
        (val, context) => {
            if (val && context.parent.cEMItem14ProductNumber) {
                const end = convertToNumber(val);
                const start = convertToNumber(
                    context.parent.cEMItem14ProductNumber
                );
                return compareTime(start, end);
            }
        }
    ),
    cEMItem15ProductNumber: Yup.string().test(
        'Compare Time',
        'Time is invalid',
        (val, context) => {
            if (val && context.parent.cEMItem15QuantityOrdered) {
                const start = convertToNumber(val);
                const end = convertToNumber(
                    context.parent.cEMItem15QuantityOrdered
                );
                return compareTime(start, end);
            } else {
                return true;
            }
        }
    ),
    cEMItem15QuantityOrdered: Yup.string().test(
        'Compare Time',
        'Time is invalid',
        (val, context) => {
            if (val && context.parent.cEMItem15ProductNumber) {
                const end = convertToNumber(val);
                const start = convertToNumber(
                    context.parent.cEMItem15ProductNumber
                );
                return compareTime(start, end);
            }
        }
    ),
    cEMItem16ProductNumber: Yup.string().test(
        'Compare Time',
        'Time is invalid',
        (val, context) => {
            if (val && context.parent.cEMItem16QuantityOrdered) {
                const start = convertToNumber(val);
                const end = convertToNumber(
                    context.parent.cEMItem16QuantityOrdered
                );
                return compareTime(start, end);
            } else {
                return true;
            }
        }
    ),
    cEMItem16QuantityOrdered: Yup.string().test(
        'Compare Time',
        'Time is invalid',
        (val, context) => {
            if (val && context.parent.cEMItem16ProductNumber) {
                const end = convertToNumber(val);
                const start = convertToNumber(
                    context.parent.cEMItem16ProductNumber
                );
                return compareTime(start, end);
            }
        }
    ),
});

// Patient Support Center
export const validationSchema_18953 = (validation, language) => {
    {
        if (language === 'kr') {
            return Yup.object({
                ...validate({ validation, key: 'FirstName' }),
                ...Email({ validation }),
                ...Phone({ validation }),
            });
        } else {
            return Yup.object({
                ...validate({ validation, key: 'FirstName' }),
                ...validate({ validation, key: 'LastName' }),
                multipurposeOptIn: Yup.array().when(['Country', 'State'], {
                    is: (Country, State) =>
                        Country === 'United States' &&
                        ['CO', 'CT', 'VA'].includes(State),
                    then: Yup.array().min(1, 'This field is required'),
                }),
                ...Email({ validation }),
                ...Phone({ validation }),
            });
        }
    }
};

// Edwards Au Login
export const validationSchema_FormAuLogin = (validation) => {
    return Yup.object({
        ...validate({ validation, key: 'FirstName' }),
        ...validate({ validation, key: 'LastName' }),
        ...ProfessionalEmailAddress({ validation }),
        ...validate({ validation, key: 'Role' }),
        ...validate({ validation, key: 'Specialty' }),
        ...validate({ validation, key: 'Country' }),
        ...validate({ validation, key: 'City' }),
        ...State({ validation }),
        ...validate({ validation, key: 'Hospital_InstitutionName' }),
        ...RegistrationNumber({ validation }),
        ...validate({ validation, key: 'PostalCode' }),
    });
};

/* === Global Supply Chain Forms === */

// Supplier Application
export const validationSchema_20940 = (validation, language) => {
    return Yup.object({
        ...validate({ validation, key: 'FirstName' }),
        ...validate({ validation, key: 'LastName' }),
        Company: Yup.string().required('Company Name is a required field'),
        ...Email({ validation }),
        ...validate({ validation, key: 'Country' }),
        ...validate({ validation, key: 'City' }),
        ...State({ validation }),
        ...PostalCode({ validation }),
        ...Phone({ validation }),
        ...validate({ validation, key: 'Product__c' }),
        ...validate({ validation, key: 'Board_Certified_In__c' }),
        ...validate({ validation, key: 'marketingRequested' }),
    });
};
